// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__2p2wb","savePackageButton":"ClientWallet_savePackageButton__myOGw"};